import React, { Component } from 'react';
import Title from './Title';
import AdapterDateFns from '@mui/lab/AdapterDateFns';
import LocalizationProvider from '@mui/lab/LocalizationProvider';
import Grid from '@mui/material/Grid';
import MobileDatePicker from '@mui/lab/MobileDatePicker';
import TextField from '@mui/material/TextField';
import Container from '@mui/material/Container';

function preventDefault(event) {
  event.preventDefault();
}

class DateBar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      startDate: new Date(),
      endDate: new Date(),
      value: new Date()
    }
  }

  render() {
    return (
      <React.Fragment>
        <Title>{`Timeline: ${this.state.startDate.toISOString()} to ${this.state.endDate.toISOString()}`}</Title>
        <Container maxWidth="lg" sx={{ mt: 2, mb: 2 }}>
          <Grid container spacing={2}>
            
            <Grid item xs={6} md={4} lg={6}>
              <LocalizationProvider dateAdapter={AdapterDateFns}>
                <MobileDatePicker
                  label="start Date"
                  value={this.state.value}
                  onChange={(newValue) => {
                    this.setState({ startDate: newValue });
                  }}
                  renderInput={(params) => <TextField {...params} />}
                />
              </LocalizationProvider>
            </Grid>
            <Grid item xs={6} md={4} lg={6}>
              <LocalizationProvider dateAdapter={AdapterDateFns}>
                <MobileDatePicker
                  label="End Date"
                  value={this.state.value}
                  onChange={(newValue) => {
                    this.setState({ endDate: newValue });
                  }}
                  renderInput={(params) => <TextField {...params} />}
                />
              </LocalizationProvider>
            </Grid>
          </Grid>
        </Container>
      </React.Fragment>
    );
  }
}

export default DateBar;
